import React, { useState, useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Tokenomics } from './components/Tokenomics';
import { Marquee } from './components/Marquee';

const MINT_ADDRESS = "2WnbKT7nZVA6Se3QrAcgka7ZtN3PbcRVxKZEYpNrP1bj";

function App() {
  const [percentage, setPercentage] = useState(1);
  const [isCharging, setIsCharging] = useState(false);

  useEffect(() => {
    // Отключаем логику зарядки - всегда 1% и не заряжается
    setPercentage(1);
    setIsCharging(false);
  }, []);

  return (
    <main className="bg-oled min-h-screen text-white font-sans selection:bg-danger/20 selection:text-white overflow-x-hidden pb-16 md:pb-20 3xl:pb-24 4xl:pb-28 5xl:pb-32">
      <Header />
      
      <div className="flex flex-col w-full">
        <Hero percentage={percentage} isCharging={isCharging} />
        
        <div className="relative">
             {/* Subtle separator gradient */}
             <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
            {/* Tokenomics временно отключен */}
            {/* <Tokenomics /> */}
        </div>
      </div>

      <Marquee />
      
      {/* Footer minimal signature */}
      <footer className="w-full py-12 text-center text-neutral-800 text-xs font-light tracking-wider lowercase">
        <p>&copy; 2026 low battery pigeon. rest easy.</p>
      </footer>
    </main>
  );
}

export default App;